import React, { useEffect, useRef } from 'react';
import './tuto.css';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const Tutorial = ({ onClose, pseudo }) => {
  const TutorialModal = withReactContent(Swal);
  const modalRef = useRef(false);

  useEffect(() => {
    modalRef.current = true;
    return () => {
      modalRef.current = false;
      Swal.close();
    };
  }, []);

  const showModal = (pseudo) => {
    if (!modalRef.current) return;
    TutorialModal.fire({
      title: `Bienvenue dans le tutoriel ${pseudo} !`,
      text: 'Pour jouer, appuie sur le bouton Suivant !',
      imageUrl: "/odn_small.jpg",
      background: "/odn_small.jpg",
      allowOutsideClick: false,
      showDenyButton: true,
      confirmButtonText: `<i class="fa-solid fa-caret-right"></i> Suivant`,
      denyButtonText: `<i class="fa-solid fa-forward"></i> Passer le tutoriel`,
      denyButtonColor: '#6e7881',
      reverseButtons: true,
    }).then((res) => {
      console.log(res);
      if (res.isConfirmed) {
        TutorialModal.close();
        showSecondModal(pseudo);
      }
      else if (res.isDenied) {
        TutorialModal.close();
        onClose();
      }
    });
  };

  const showSecondModal = (pseudo) => {
    if (!modalRef.current) return;
    TutorialModal.fire({
      title: `C'est quoi cet aliment ?`,
      text: 'Tu as droit à 3 tentatives !',
      imageUrl: "/tuto1.gif",
      // imageWidth: 400,
      imageHeight: 500,
      showCancelButton: true,
      confirmButtonText: "Suivant",
      cancelButtonText: "Précédent",
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((res) => {
      if (res.isConfirmed) {
        TutorialModal.close();
        showFinalModal(pseudo);
      }
      else {
        showModal(pseudo);
      }
    });
  }

  const showFinalModal = (pseudo) => {
    if (!modalRef.current) return;
    TutorialModal.fire({
      title: `Et sa saison favorite ?`,
      text: `Tu n'as droit qu'à 1 réponse !`,
      imageUrl: "/tuto2.gif",
      // imageWidth: 400,
      imageHeight: 500,
      confirmButtonText: "C'est parti !",
      cancelButtonText: "Précédent",
      showCancelButton: true,
      reverseButtons: true,
      allowOutsideClick: false,
    }).then((res) => {
      if (res.isConfirmed) {
        TutorialModal.close();
        onClose();
      }
      else {
        showSecondModal(pseudo);
      }
    });
  }
  useEffect(() => {
    showModal(pseudo);
  }, [pseudo]);

  return null;
};

export default Tutorial;

